import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import snakeCase from "lodash/snakeCase";
import pickBy from "lodash/pickBy";

function prepareRequestData(payload) {
  return Object.entries(payload).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined) {
      acc[snakeCase(key)] = Array.isArray(value)
        ? value.join(",")
        : value.toString();
    }
    return acc;
  }, {});
}

export default {
  getReviews(payload = {}, params = {}) {
    return apiService.post(
      endpoints.reviewBooster.reviews,
      prepareRequestData(payload),
      { params: prepareRequestData(params) }
    );
  },
  updateCategory(reviewId, categoryId, payload) {
    return apiService.patch(
      endpoints.reviewBooster.reviewBoosterReviewCategory(reviewId, categoryId),
      payload
    );
  },
  unassignCategory(reviewId, categoryId) {
    return apiService.delete(
      endpoints.reviewBooster.reviewBoosterReviewCategory(reviewId, categoryId)
    );
  },
  assignCategory(reviewId, payload) {
    return apiService.post(
      endpoints.reviewBooster.reviewBoosterReviewCategories(reviewId),
      payload
    );
  },
  getReviewBoosterList(params = {}) {
    return apiService.get(endpoints.reviewBooster.reviewBoosterSettings, {
      params
    });
  },
  exportReviewBoosterLinks(key, file_format) {
    return apiService.get(
      endpoints.reviewBooster.reviewBoosterLinksExport(key),
      { params: { file_format }, responseType: "blob" }
    );
  },
  exportReviewBoosterStats(key, params = {}, file_format) {
    return apiService.post(
      endpoints.reviewBooster.reviewBoosterStatsExport(key),
      { filters: prepareRequestData(params), file_format }
    );
  },

  exportReviews(payload = {}, key, file_format = "csv") {
    const review_booster_key = key;
    return apiService.post(endpoints.reviewBooster.exportReviews, {
      filters: pickBy(prepareRequestData(payload)),
      review_booster_key,
      file_format
    });
  }
};
